import {
  deleteApi,
  getApi,
  patchApi,
  postApi,
  putApi,
} from '../../../utils/api'
import { DOC_FLOW_API_URL } from '../DocFlow.constants'

import { DOC_FLOW_COMBINING_TABLE_CONFIG_URL } from './DocFlowCombining.constants'

export function updateTableConfig(data) {
  return putApi({
    data,
    endpoint: `${DOC_FLOW_COMBINING_TABLE_CONFIG_URL}config/`,
  })
}

export function addNewCombining({ id, ...restData }) {
  return postApi({
    data: restData,
    endpoint: `${DOC_FLOW_API_URL}${id}/combining-files/`,
  })
}

export function updateCombining({ combiningId, documentId, ...restData }) {
  return patchApi({
    data: restData,
    endpoint: `${DOC_FLOW_API_URL}${documentId}/combining-files/${combiningId}/`,
  })
}

export function deleteCombining({ combiningId, documentId }) {
  return deleteApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/combining-files/${combiningId}/`,
  })
}

export function checkCombiningTask(id) {
  return getApi({ endpoint: `api/system/async_task/${id}/` })
}

export function performDocFlowCombiningMassAction(documentId, data) {
  return postApi({
    data,
    endpoint: `${DOC_FLOW_API_URL}${documentId}/combining-files/mass-action/`,
  })
}
